import '../reset.css';
import '../style.css';
import '../styles/glossary.css';
import {userBrowserId} from '../scripts/common.js';
import {initIframeResize} from './_inIFrame.js';

initIframeResize();

void userBrowserId;

const glossary = [
  ['Distinct', `Different; not equal to each other.`, 1],
  ['Integer', `A whole number: ..., -2, -1, 0, 1, 2, ... (no fractions).`, 1],
  ['Lateral Side', `In an isosceles triangle, these are the two sides that are equal in length (distinct from the 'base').`, 1],
  ['Perpendicular Bisector', `A line that cuts a line segment exactly in half at a 90° angle.`, 1],
  ['Adjacent', `Next to each other. Used for cells in a grid or angles sharing a side.`, 2],
  ['Consecutive', `Integers that go one after another, with difference 1 (e.g., 5, 6, 7).`, 2],
  ['Equation', `A statement with an equals sign (=) saying two expressions are equal.`, 2],
  ['Rational Number', `A number that can be written as a fraction p/q (where p and q are integers, q ≠ 0). Contrast with irrational numbers like √2.`, 2],
  ['Variable', `A symbol (often a letter) that represents a number that can change or is unknown.`, 2],
  ['Digit', `The symbols 0, 1, 2, ..., 9 used to write numbers. (Distinct from 'Number': 2025 is a number, 2 is a digit).`, 3],
  ['Respectively', `In the same order as the items were listed.`, 3],
  ['Evaluate', `To calculate the value of an expression.`, 4],
  ['Real Root', `A solution to an equation that is a real number (not imaginary).`, 4],
  ['Solution', `A value (or values) that makes an equation or a system true.`, 4],
  ['Acute Angle', `An angle greater than 0° but less than 90°.`, 5],
  ['Angle Bisector', `A ray or line that splits an angle into two equal angles.`, 5],
  ['Convex (Polygon)', `A polygon where all interior angles are less than 180° and no vertices point 'inwards'.`, 5],
  ['Diagonal', `A line segment connecting two non-adjacent vertices of a polygon (e.g., opposite corners of a square).`, 5],
  ['Median (Geometry)', `In a triangle: a segment from a vertex to the midpoint of the opposite side.`, 5],
  ['Obtuse Angle', `An angle greater than 90° but less than 180°.`, 5],
  ['Prove', `To show a statement is true using logical steps based on definitions and known facts.`, 5],
  ['Isosceles Triangle', `A triangle with at least two equal sides.`, 6],
  ['Rhombus', `A quadrilateral with all four sides of equal length (a 'slanted' square).`, 6],
  ['Expanded Form', `Writing a polynomial as a sum of terms (e.g., x² + 2x - 3) rather than a product (e.g., (x-1)(x+3)).`, 7],
  ['Perimeter', `The total length around the boundary of a shape.`, 7],
  ['Absolute Value', `The distance of a number from 0 on the number line; always non-negative.`, 8],
  ['Chord', `A line segment connecting two points on the circle (the diameter is the longest chord).`, 8],
  ['Coordinate Plane', `A plane with two perpendicular number lines (x-axis and y-axis) crossing at (0,0).`, 8],
  ['System of Equations', `Two or more equations with the same variables, solved together.`, 9],
  ['Acute Triangle', `A triangle where all three angles are acute (each less than 90°).`, 10],
  ['Edge (of a solid)', `The line segment where two faces of a 3D object meet (e.g., a cube has 12 edges).`, 10],
  ['Face (of a solid)', `A flat surface of a 3D object (e.g., a cube has 6 faces).`, 10],
  ['Obtuse Triangle', `A triangle with one obtuse angle (greater than 90°); the other two must be acute.`, 10],
  ['Tangent (to a circle)', `A line that touches a circle at exactly one point.`, 10],
  ['Coefficient', `A number that multiplies a variable (e.g., 7 in 7x).`, 12],
  ['Polynomial', `An expression like a₀ + a₁x + a₂x² + ... with only non-negative integer powers of the variable.`, 12],
  ['Simultaneously', `Happening at exactly the same time.`, 12],
  ['Quadratic', `An expression or equation where the highest power of the variable is 2 (e.g., ax² + bx + c, with a ≠ 0).`, 13],
  ['Remainder', `The amount 'left over' after dividing one integer by another. In division a = bq + r, the remainder is r, where 0 ≤ r < |b|.`, 14],
  ['Equilateral', `A triangle with all sides equal (so all angles are equal too).`, 15],
  ['Factorise', `To rewrite a number or expression as a product of factors (a multiplication).`, 15],
  ['Incircle', `A circle inside a polygon (often a triangle) that touches every side at exactly one point.`, 18],
  ['Mean (Average)', `The sum of values divided by the number of values.`, 20],
  ['Intersection', `The point(s) that two figures have in common (where they meet).`, 22],
  ['Convex', `A shape is convex if the segment between any two points of the shape stays inside it.`, 25],
  ['Simplify', `To rewrite an expression in an equivalent but simpler form.`, 25],
  ['Expression', `A mathematical “formula” made of numbers/variables/operations, with no equals sign.`, 30],
  ['Vertices', `Corner points of a shape (singular: vertex).`, 30],
  ['Difference of Squares', `The identity a² - b² = (a - b)(a + b).`, 35],
  ['Sequence', `An ordered list of numbers; each number is a term.`, 35],
  ['Constant Speed', `Speed that stays the same over time.`, 40],
  ['Linear Equation', `An equation where variables have power 1 only; its graph is a straight line.`, 45],
  ['Natural Number', `Counting numbers: 1, 2, 3, ... (sometimes 0 too; check the context).`, 50],
  ['Arithmetic Sequence', `A sequence where the difference between consecutive terms is constant.`, 55],
  ['Midpoint', `The point that divides a segment into two equal parts.`, 60],
  ['Denominator', `The bottom number of a fraction; it cannot be 0.`, 65],
  ['Numerator', `The top number of a fraction.`, 65],
  ['Origin', `The point (0, 0) where the axes meet in the coordinate plane.`, 70],
  ['Slope (Gradient)', `How steep a line is: change in y divided by change in x (rise/run).`, 80],
  ['Parabola', `The graph of a quadratic function (e.g., y = ax² + bx + c); it is U-shaped.`, 85],
  ['Hypotenuse', `In a right triangle: the side opposite the right angle (the longest side).`, 90],
  ['Right Angle', `An angle of exactly 90 degrees.`, 95],
  ['Arbitrary', `Any chosen value; not special.`, 99],
  ['Magnitude', `Size or length: for a vector, its length; for a number, its absolute value.`, 100],
];

const STORAGE_KEY = 'tlf_math_glossary_v1';
const SORT_STORAGE_KEY = 'tlf_math_glossary_sort_v1';
const STORAGE_VERSION = 3;
const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const MASTERED_BOX = 3;
const GOOD_INTERVALS_BY_BOX = [6 * HOUR, 16 * HOUR, 30 * HOUR, 42 * HOUR];

const dom = {
  heroTotalTerms: document.getElementById('hero-total-terms'),
  heroDueNow: document.getElementById('hero-due-now'),
  heroMastered: document.getElementById('hero-mastered'),
  resetPlanBtn: document.getElementById('reset-plan-btn'),
  daySummary: document.getElementById('day-summary'),
  statUnlockedToday: document.getElementById('stat-unlocked-today'),
  statNewToday: document.getElementById('stat-new-today'),
  statLearning: document.getElementById('stat-learning'),
  flashcard: document.getElementById('flashcard'),
  flashcardLabel: document.getElementById('flashcard-label'),
  flashcardTerm: document.getElementById('flashcard-term'),
  flashcardDefinition: document.getElementById('flashcard-definition'),
  flashcardHelp: document.getElementById('flashcard-help'),
  showAnswerBtn: document.getElementById('show-answer-btn'),
  nextCardBtn: document.getElementById('next-card-btn'),
  ratingRow: document.getElementById('rating-row'),
  queueMessage: document.getElementById('queue-message'),
  termSearch: document.getElementById('term-search'),
  sortMode: document.getElementById('sort-mode'),
  glossaryList: document.getElementById('glossary-list'),
};

let sortMode = loadSortMode();
let state = loadState();
let currentCardId = resolveCurrentCardId();
let isCardRevealed = false;
let lastActionMessage = '';

function clampInteger(value, min, max) {
  if (!Number.isFinite(value)) {
    return min;
  }
  return Math.min(max, Math.max(min, Math.round(value)));
}

function sanitizePriority(value) {
  return clampInteger(Number(value), 1, 100);
}

function normalizeSortMode(value) {
  return value === 'name' ? 'name' : 'priority';
}

function makeCardKey(term) {
  return String(term).trim().toLowerCase();
}

function getEmptyProgress(term, definition, priority) {
  return {
    term,
    definition,
    priority: sanitizePriority(priority),
    box: 0,
    dueAt: 0,
    seenCount: 0,
    reviewCount: 0,
    lastRating: null,
    lastSeenAt: 0,
    masteredAt: 0,
  };
}

function createCard(term, definition, priority, index, progress) {
  return {
    id: index,
    key: makeCardKey(term),
    term,
    definition,
    priority: sanitizePriority(priority),
    box: clampInteger(progress.box, 0, MASTERED_BOX),
    dueAt: Number.isFinite(progress.dueAt) ? progress.dueAt : 0,
    seenCount: clampInteger(progress.seenCount, 0, 100000),
    reviewCount: clampInteger(progress.reviewCount, 0, 100000),
    lastRating: ['again', 'hard', 'good', 'easy'].includes(progress.lastRating) ? progress.lastRating : null,
    lastSeenAt: Number.isFinite(progress.lastSeenAt) ? progress.lastSeenAt : 0,
    masteredAt: Number.isFinite(progress.masteredAt) ? progress.masteredAt : 0,
  };
}

function cardToProgress(card) {
  return {
    term: card.term,
    definition: card.definition,
    priority: card.priority,
    box: card.box,
    dueAt: card.dueAt,
    seenCount: card.seenCount,
    reviewCount: card.reviewCount,
    lastRating: card.lastRating,
    lastSeenAt: card.lastSeenAt,
    masteredAt: card.masteredAt,
  };
}

function normalizeProgress(raw) {
  if (!raw || typeof raw.term !== 'string' || typeof raw.definition !== 'string') {
    return null;
  }

  return {
    term: raw.term,
    definition: raw.definition,
    priority: sanitizePriority(raw.priority),
    box: clampInteger(raw.box, 0, MASTERED_BOX),
    dueAt: Number.isFinite(raw.dueAt) ? raw.dueAt : 0,
    seenCount: clampInteger(raw.seenCount, 0, 100000),
    reviewCount: clampInteger(raw.reviewCount, 0, 100000),
    lastRating: ['again', 'hard', 'good', 'easy'].includes(raw.lastRating) ? raw.lastRating : null,
    lastSeenAt: Number.isFinite(raw.lastSeenAt) ? raw.lastSeenAt : 0,
    masteredAt: Number.isFinite(raw.masteredAt) ? raw.masteredAt : 0,
  };
}

function loadSortMode() {
  try {
    return normalizeSortMode(window.localStorage.getItem(SORT_STORAGE_KEY));
  } catch (error) {
    return 'priority';
  }
}

function persistSortMode() {
  window.localStorage.setItem(SORT_STORAGE_KEY, sortMode);
}

function createFreshState() {
  const bank = {};
  const cards = glossary.map(([term, definition, priority], index) => {
    const progress = getEmptyProgress(term, definition, priority);
    bank[makeCardKey(term)] = progress;
    return createCard(term, definition, priority, index, progress);
  });

  return {
    version: STORAGE_VERSION,
    bank,
    cards,
    lastCardKey: null,
  };
}

function extractLegacyBank(parsed) {
  const bank = {};

  if (parsed && parsed.bank && typeof parsed.bank === 'object') {
    Object.keys(parsed.bank).forEach((key) => {
      const progress = normalizeProgress(parsed.bank[key]);
      if (progress) {
        bank[makeCardKey(progress.term)] = progress;
      }
    });
  }

  if (parsed && Array.isArray(parsed.cards)) {
    parsed.cards.forEach((rawCard) => {
      const progress = normalizeProgress(rawCard);
      if (progress) {
        bank[makeCardKey(progress.term)] = progress;
      }
    });
  }

  return bank;
}

function composeStateFromBank(bank, lastCardKey) {
  const nextBank = {...bank};
  const cards = glossary.map(([term, definition, priority], index) => {
    const key = makeCardKey(term);
    const progress = nextBank[key] || getEmptyProgress(term, definition, priority);
    const card = createCard(term, definition, priority, index, progress);
    nextBank[key] = cardToProgress(card);
    return card;
  });

  return {
    version: STORAGE_VERSION,
    bank: nextBank,
    cards,
    lastCardKey: typeof lastCardKey === 'string' ? makeCardKey(lastCardKey) : null,
  };
}

function loadState() {
  const freshState = createFreshState();

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        version: freshState.version,
        bank: freshState.bank,
        lastCardKey: freshState.lastCardKey,
      }));
      return freshState;
    }

    const parsed = JSON.parse(raw);
    const legacyBank = extractLegacyBank(parsed);

    let lastCardKey = null;
    if (typeof parsed?.lastCardKey === 'string') {
      lastCardKey = parsed.lastCardKey;
    } else if (Number.isInteger(parsed?.lastCardId) && Array.isArray(parsed?.cards)) {
      const lastCard = parsed.cards.find((card) => card && card.id === parsed.lastCardId && typeof card.term === 'string');
      if (lastCard) {
        lastCardKey = makeCardKey(lastCard.term);
      }
    }

    const restoredState = composeStateFromBank(legacyBank, lastCardKey);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
      version: restoredState.version,
      bank: restoredState.bank,
      lastCardKey: restoredState.lastCardKey,
    }));
    return restoredState;
  } catch (error) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
      version: freshState.version,
      bank: freshState.bank,
      lastCardKey: freshState.lastCardKey,
    }));
    return freshState;
  }
}

function persistState() {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
    version: STORAGE_VERSION,
    bank: state.bank,
    lastCardKey: state.lastCardKey,
  }));
}

function resolveCurrentCardId() {
  if (typeof state.lastCardKey !== 'string') {
    return null;
  }
  const card = state.cards.find((item) => item.key === state.lastCardKey);
  return card ? card.id : null;
}

function syncCardToBank(card) {
  state.bank[card.key] = cardToProgress(card);
}

function compareTerms(a, b) {
  return a.term.localeCompare(b.term, 'en', {sensitivity: 'base'});
}

function getSortComparator() {
  if (sortMode === 'name') {
    return (a, b) => {
      const nameCmp = compareTerms(a, b);
      if (nameCmp !== 0) {
        return nameCmp;
      }
      return a.priority - b.priority;
    };
  }

  return (a, b) => {
    if (a.priority !== b.priority) {
      return a.priority - b.priority;
    }
    return compareTerms(a, b);
  };
}

function sortCards(cards) {
  return [...cards].sort(getSortComparator());
}

function getStudyQueue(nowMs) {
  const pendingCards = state.cards.filter((card) => card.masteredAt === 0);
  const dueCards = sortCards(pendingCards.filter((card) => card.dueAt <= nowMs));
  const laterCards = sortCards(pendingCards.filter((card) => card.dueAt > nowMs));
  return dueCards.concat(laterCards);
}

function getCardById(cardId) {
  if (!Number.isInteger(cardId)) {
    return null;
  }
  return state.cards.find((card) => card.id === cardId) || null;
}

function formatDelay(ms) {
  if (ms <= MINUTE) {
    return 'under a minute';
  }
  if (ms < HOUR) {
    return `${Math.ceil(ms / MINUTE)} min`;
  }
  return `${Math.ceil(ms / HOUR)} h`;
}

function getCardStatus(card, nowMs) {
  if (card.masteredAt > 0) {
    return {label: 'Good', className: 'glossary-pill glossary-pill-mastered'};
  }
  if (card.seenCount === 0) {
    return {label: 'New', className: 'glossary-pill glossary-pill-new'};
  }
  if (card.dueAt <= nowMs) {
    return {label: 'Repeat now', className: 'glossary-pill glossary-pill-learning'};
  }
  return {label: 'Repeat', className: 'glossary-pill glossary-pill-learning'};
}

function getQueueMessage(queue) {
  if (queue.length === 0) {
    return lastActionMessage || 'All cards are in good shape.';
  }
  return lastActionMessage || `Cards in rotation: ${queue.length}`;
}

function setRatingEnabled(enabled) {
  dom.ratingRow.classList.toggle('is-disabled', !enabled);
}

function revealCard() {
  if (currentCardId === null || isCardRevealed) {
    return;
  }

  isCardRevealed = true;
  dom.flashcard.classList.add('is-revealed');
  dom.flashcardLabel.textContent = 'Definition';
  dom.flashcardDefinition.classList.remove('is-hidden');
  dom.flashcardHelp.textContent = 'Rate your recall: 1 Again, 2 Hard, 3 Good, 4 Easy';
  dom.showAnswerBtn.disabled = true;
  setRatingEnabled(true);
}

function renderCard(queue) {
  const activeInQueue = queue.find((card) => card.id === currentCardId);
  if (!activeInQueue) {
    currentCardId = queue[0] ? queue[0].id : null;
    isCardRevealed = false;
  }

  const activeCard = getCardById(currentCardId);
  if (!activeCard) {
    dom.flashcard.classList.remove('is-revealed');
    dom.flashcardLabel.textContent = 'Status';
    dom.flashcardTerm.textContent = 'All cards are in good shape';
    dom.flashcardDefinition.textContent = 'Use reset if you want to start this deck from scratch.';
    dom.flashcardDefinition.classList.remove('is-hidden');
    dom.flashcardHelp.textContent = 'No pending cards.';
    dom.showAnswerBtn.disabled = true;
    dom.nextCardBtn.disabled = true;
    setRatingEnabled(false);
    return;
  }

  dom.nextCardBtn.disabled = queue.length <= 1;
  dom.showAnswerBtn.disabled = isCardRevealed;

  if (!isCardRevealed) {
    dom.flashcard.classList.remove('is-revealed');
    dom.flashcardLabel.textContent = 'Term';
    dom.flashcardTerm.textContent = activeCard.term;
    dom.flashcardDefinition.textContent = activeCard.definition;
    dom.flashcardDefinition.classList.add('is-hidden');
    dom.flashcardHelp.textContent = 'Tap card or press Space to reveal';
    setRatingEnabled(false);
    return;
  }

  dom.flashcard.classList.add('is-revealed');
  dom.flashcardLabel.textContent = 'Definition';
  dom.flashcardTerm.textContent = activeCard.term;
  dom.flashcardDefinition.textContent = activeCard.definition;
  dom.flashcardDefinition.classList.remove('is-hidden');
  dom.flashcardHelp.textContent = 'Rate your recall: 1 Again, 2 Hard, 3 Good, 4 Easy';
  setRatingEnabled(true);
}

function applyRating(card, rating, nowMs) {
  card.reviewCount += 1;
  card.seenCount += 1;
  card.lastRating = rating;
  card.lastSeenAt = nowMs;

  if (rating === 'again') {
    card.box = 0;
    card.dueAt = nowMs + (10 * MINUTE);
    card.masteredAt = 0;
    lastActionMessage = 'Again: repeat in 10 min.';
    return;
  }

  if (rating === 'hard') {
    const hardDelay = card.box === 0 ? (2 * HOUR) : Math.max(4 * HOUR, Math.round(GOOD_INTERVALS_BY_BOX[card.box] * 0.6));
    card.dueAt = nowMs + hardDelay;
    card.masteredAt = 0;
    lastActionMessage = `Hard: repeat in ${formatDelay(hardDelay)}.`;
    return;
  }

  if (rating === 'good') {
    card.box = Math.min(MASTERED_BOX, card.box + 1);
    const goodDelay = GOOD_INTERVALS_BY_BOX[card.box];
    card.dueAt = nowMs + goodDelay;
    card.masteredAt = card.box >= MASTERED_BOX ? nowMs : 0;
    lastActionMessage = card.masteredAt > 0 ? 'Good: card moved to good.' : `Good: repeat in ${formatDelay(goodDelay)}.`;
    return;
  }

  if (rating === 'easy') {
    card.box = Math.min(MASTERED_BOX, card.box + 2);
    const easyDelay = Math.max(16 * HOUR, GOOD_INTERVALS_BY_BOX[card.box]);
    card.dueAt = nowMs + easyDelay;
    card.masteredAt = card.box >= MASTERED_BOX ? nowMs : 0;
    lastActionMessage = card.masteredAt > 0 ? 'Easy: card moved to good.' : `Easy: repeat in ${formatDelay(easyDelay)}.`;
  }
}

function moveToNextCard(queue) {
  if (queue.length === 0) {
    currentCardId = null;
    isCardRevealed = false;
    return;
  }

  if (currentCardId === null) {
    currentCardId = queue[0].id;
    isCardRevealed = false;
    return;
  }

  const currentIndex = queue.findIndex((card) => card.id === currentCardId);
  if (currentIndex === -1) {
    currentCardId = queue[0].id;
    isCardRevealed = false;
    return;
  }

  const nextIndex = (currentIndex + 1) % queue.length;
  currentCardId = queue[nextIndex].id;
  isCardRevealed = false;
}

function escapeHtml(text) {
  return String(text)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll('\'', '&#039;');
}

function renderGlossaryList(nowMs) {
  const query = dom.termSearch.value.trim().toLowerCase();
  const cardsToRender = sortCards(state.cards).filter((card) => {
    if (!query) {
      return true;
    }
    return card.term.toLowerCase().includes(query) || card.definition.toLowerCase().includes(query);
  });

  dom.glossaryList.innerHTML = cardsToRender.map((card) => {
    const status = getCardStatus(card, nowMs);
    const repeatLabel = card.masteredAt > 0 ?
      'Good' :
      card.seenCount === 0 ?
        'Not seen yet' :
        card.dueAt <= nowMs ?
          'Repeat now' :
          `Repeat in ${formatDelay(card.dueAt - nowMs)}`;

    return `
      <li class="glossary-item">
        <div class="glossary-item-top">
          <strong class="glossary-item-term">${escapeHtml(card.term)}</strong>
          <div class="glossary-item-badges">
            <span class="${status.className}">${status.label}</span>
          </div>
        </div>
        <p class="glossary-item-def">${escapeHtml(card.definition)}</p>
        <p class="glossary-subline">${escapeHtml(repeatLabel)}</p>
      </li>
    `;
  }).join('');
}

function renderStats(queue) {
  const newCount = state.cards.filter((card) => card.seenCount === 0).length;
  const repeatCount = state.cards.filter((card) => card.seenCount > 0 && card.masteredAt === 0).length;
  const goodCount = state.cards.filter((card) => card.masteredAt > 0).length;

  dom.heroTotalTerms.textContent = String(newCount);
  dom.heroDueNow.textContent = String(repeatCount);
  dom.heroMastered.textContent = String(goodCount);

  dom.statUnlockedToday.textContent = String(newCount);
  dom.statNewToday.textContent = String(repeatCount);
  dom.statLearning.textContent = String(goodCount);

  const sortLabel = sortMode === 'priority' ? 'priority' : 'name';
  dom.daySummary.textContent = `Continuous mode - sorted by ${sortLabel} (${queue.length} active)`;
}

function render() {
  const nowMs = Date.now();
  const queue = getStudyQueue(nowMs);
  renderStats(queue);
  renderCard(queue);
  renderGlossaryList(nowMs);
  dom.queueMessage.textContent = getQueueMessage(queue);
}

function onRate(rating) {
  if (!isCardRevealed || currentCardId === null) {
    return;
  }

  const card = getCardById(currentCardId);
  if (!card) {
    return;
  }

  applyRating(card, rating, Date.now());
  syncCardToBank(card);
  state.lastCardKey = card.key;
  persistState();

  moveToNextCard(getStudyQueue(Date.now()));
  render();
}

function onResetPlan() {
  const shouldReset = window.confirm('Reset all flashcard progress?');
  if (!shouldReset) {
    return;
  }

  state.cards.forEach((card) => {
    const clean = getEmptyProgress(card.term, card.definition, card.priority);
    card.box = clean.box;
    card.dueAt = clean.dueAt;
    card.seenCount = clean.seenCount;
    card.reviewCount = clean.reviewCount;
    card.lastRating = clean.lastRating;
    card.lastSeenAt = clean.lastSeenAt;
    card.masteredAt = clean.masteredAt;
    syncCardToBank(card);
  });

  state.lastCardKey = null;
  currentCardId = null;
  isCardRevealed = false;
  lastActionMessage = 'Progress reset.';
  persistState();
  render();
}

function onKeyboardShortcuts(event) {
  const target = event.target;
  if (target && ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)) {
    return;
  }

  if (event.code === 'Space') {
    event.preventDefault();
    revealCard();
    render();
    return;
  }

  if (!isCardRevealed) {
    return;
  }

  if (event.key === '1') {
    event.preventDefault();
    onRate('again');
  } else if (event.key === '2') {
    event.preventDefault();
    onRate('hard');
  } else if (event.key === '3') {
    event.preventDefault();
    onRate('good');
  } else if (event.key === '4') {
    event.preventDefault();
    onRate('easy');
  }
}

function initHandlers() {
  dom.flashcard.addEventListener('click', () => {
    revealCard();
    render();
  });

  dom.showAnswerBtn.addEventListener('click', () => {
    revealCard();
    render();
  });

  dom.nextCardBtn.addEventListener('click', () => {
    moveToNextCard(getStudyQueue(Date.now()));
    lastActionMessage = '';
    render();
  });

  dom.ratingRow.querySelectorAll('[data-rating]').forEach((button) => {
    button.addEventListener('click', () => {
      onRate(button.dataset.rating);
    });
  });

  dom.termSearch.addEventListener('input', () => {
    renderGlossaryList(Date.now());
  });

  dom.sortMode.addEventListener('change', () => {
    sortMode = normalizeSortMode(dom.sortMode.value);
    persistSortMode();
    currentCardId = null;
    isCardRevealed = false;
    lastActionMessage = '';
    render();
  });

  dom.resetPlanBtn.addEventListener('click', onResetPlan);
  document.addEventListener('keydown', onKeyboardShortcuts);
}

function init() {
  dom.sortMode.value = sortMode;
  initHandlers();
  render();
}

init();
